import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Luggage, ArrowRight } from "lucide-react";
import api from "../../lib/api";

/* Compact Travel Hub banner for the Luggage & Gear Inventory. */
export default function GearSection() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/gear/overview").then((r) => setStats(r.data.stats)).catch(() => {}); }, []);

  return (
    <div data-testid="hub-gear-section">
      <h2 className="font-heading font-900 text-[#F9AB00] text-2xl mb-4 flex items-center gap-2">
        <Luggage className="w-6 h-6" /> Luggage &amp; Gear Inventory
      </h2>
      <Link to="/gear" data-testid="hub-gear-link"
        className="group flex flex-wrap items-center gap-4 border border-zinc-300 bg-white p-5 hover:border-amber-500 hover:shadow-lg transition-all">
        <div className="flex-1 min-w-[240px]">
          <div className="font-700">Every bag, every item — tracked from home and back</div>
          <p className="text-sm text-muted-foreground mt-1">
            Photograph your bags to spot them at the belt, assign items to owners, check packing progress,
            run the AI "did you forget anything?" check, and file lost-item reports.
          </p>
        </div>
        {stats && (
          <div className="flex gap-5 text-center">
            {[[stats.bags, "bags"], [stats.items, "items"], [`${stats.packing_pct}%`, "packed"]].map(([v, l]) => (
              <div key={l}>
                <div className="font-heading font-900 text-2xl text-amber-600">{v}</div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">{l}</div>
              </div>
            ))}
          </div>
        )}
        <span className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-bold bg-amber-500 text-white group-hover:bg-amber-600 transition-colors shrink-0">
          Open inventory <ArrowRight className="w-4 h-4" />
        </span>
      </Link>
    </div>
  );
}
